'use client';

import { useEffect } from 'react';

import { trackError } from '@monoimin/error-boundary';
import { ResetDueError } from '@monoimin/templates/components/reset-due-error/ResetDueError';
import { ErrorPageProps } from '@monoimin/sb-types';

export default function GlobalErrorPage({ error, reset }: ErrorPageProps) {
  useEffect(() => {
    trackError(error);
  }, [error]);

  return (
    <html lang='en'>
      <body>
        <ResetDueError reset={reset} />;
      </body>
    </html>
  );
}
